import $ from 'jquery';
import WindowPopup from './utils/window-popup';
import changeWindowUrl from './utils/change-url';

class SocialSharing {
    constructor($socialLinksSelector) {
        this.$socialLinksSelector = $socialLinksSelector;

        this.watchForClick();
    }

    watchForClick() {
        "use strict";

        if (this.$socialLinksSelector.length > 0) {
            $('body').on('click', this.$socialLinksSelector, function (e) {
                e.preventDefault();
                let shareUrl = $(this).data('url');
                let href = $(this).attr('href');

                if (shareUrl !== undefined && shareUrl.length) {
                    shareUrl = window.location.protocol + '//' + window.location.hostname + shareUrl;
                    href += encodeURI(shareUrl);
                }

                WindowPopup(href, 500, 300);
            });
        }

        changeWindowUrl('', true, true);
    }
}

export default SocialSharing;
